var _ellipse, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFluxIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 338.064,
    height: 335.661,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 64",
    cx: 169.032,
    cy: 167.831,
    rx: 169.032,
    ry: 167.831,
    fill: "#2b61d1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 179",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 73",
    d: "m189.285 265.438-19.224 11.107-41.3-23.841 18.756-10.832.469-.276.717.413Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 74",
    d: "M263.081 115.435v22.352l-40.653-23.469-11.025-6.367-11.025 6.367-51.677 29.836-11.025 6.367v13.16l-19.885-11.479-11.025-6.367-11.025 6.367-18.7 10.79v-47.557l93.02-53.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 75",
    d: "M263.082 163.254v59.671l-51.678 29.835-.069-.041-51.609-29.794v-59.671l51.678-29.849Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 76",
    d: "M136.491 188.459v34.314l-29.725 17.171-29.725-17.171v-34.314l29.725-17.157Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluxIcon);
export default __webpack_public_path__ + "static/media/fluxIcon.074129ec7cac195feacb01b021aeda87.svg";
export { ForwardRef as ReactComponent };